export default __webpack_public_path__ + "media/images/icons/icon-arrow-pagination-prev-11be23266cec54fd22dfb9b717f2cb24.svg";